import {DEVELOPER_ROLE, DEVOPS_ROLE, SALES_ROLE, SUPPORT_ROLE, SYSTEM_ROLE, UNKNOWN_ROLE} from "./adminRoles";

const navBarRoutes = {
    nodes: {
        path: "/nodes",
        icon: "router",
        label: "Nodes",
    },
    nodeServerBundles: {
        path: "/server-bundles",
        icon: "library_books",
        label: "Server Bundles",
    },
    shortcutSearch: {
        path: "/shortcut-search",
        icon: "search",
        label: "Shortcut search",
    },
    shortcutReviewMode: {
        path: "/shortcuts/review-mode",
        icon: "remove_red_eye",
        label: "Shortcut Review Mode",
    },
    shortcutGroupsV2: {
        path: "/shortcuts/v2/groups",
        icon: "list",
        label: "Shortcut Groups",
    },
    shortcutsV2: {
        path: "/shortcuts/v2",
        icon: "add_photo_alternate",
        label: "Shortcuts",
    },
    enhancersV2: {
        path: "/shortcuts/v2/enhancers",
        icon: "tips_and_updates",
        label: "Enhancers",
    },
    store: {
        path: "/store",
        icon: "storefront",
        label: "Store",
    },
    promocodes: {
        path: "/promocodes",
        icon: "request_quote",
        label: "Promocodes",
    },
    promocodeGroups: {
        path: "/promocodes/groups",
        icon: "table_view",
        label: "Promocode Groups",
    },
    apiTokens: {
        path: "/api-tokens",
        icon: "pin",
        label: "API Tokens",
    },
    users: {
        path: "/users",
        icon: "people",
        label: "Users",
    },
    searchUserByAppleOrder: {
        path: "/users/apple-order-id",
        icon: "apple",
        label: "Apple Order Search",
    },
    accountCodes: {
        path: "/users/generate-account-codes",
        icon: "military_tech",
        label: "Account codes",
    },
    adminManagement: {
        path: "/admin-management",
        icon: "admin_panel_settings",
        label: "Admin Management",
    }
};

export const defaultNavBarTree = [
    {
        ...navBarRoutes.nodes,
        children: [
          navBarRoutes.nodeServerBundles,
        ]
    },
    {
        ...navBarRoutes.shortcutGroupsV2,
        children: [
            navBarRoutes.shortcutsV2,
            navBarRoutes.enhancersV2,
            navBarRoutes.shortcutSearch,
            navBarRoutes.shortcutReviewMode,
        ]
    },
    navBarRoutes.store,
    {
        ...navBarRoutes.promocodes,
        children: [
            navBarRoutes.promocodeGroups,
        ]
    },
    navBarRoutes.apiTokens,
    {
        ...navBarRoutes.users,
        children: [
            navBarRoutes.searchUserByAppleOrder,
            navBarRoutes.accountCodes,
        ]
    },
    navBarRoutes.adminManagement
];

export const navBarLinksByRoles = {
    [UNKNOWN_ROLE]: defaultNavBarTree,
    [SYSTEM_ROLE]: defaultNavBarTree,
    [SALES_ROLE]: [
        navBarRoutes.users,
        navBarRoutes.shortcutSearch,
        {
            ...navBarRoutes.promocodes,
            children: [
                navBarRoutes.promocodeGroups,
            ]
        }
    ],
    [DEVELOPER_ROLE]: [
        {
            ...navBarRoutes.nodes,
            children: [
                navBarRoutes.nodeServerBundles,
            ]
        },
        {
            ...navBarRoutes.shortcutGroupsV2,
            children: [
                navBarRoutes.shortcutsV2,
                navBarRoutes.enhancersV2,
                navBarRoutes.shortcutSearch,
                navBarRoutes.shortcutReviewMode,
            ]
        },
        navBarRoutes.store,
        {
            ...navBarRoutes.promocodes,
            children: [
                navBarRoutes.promocodeGroups,
            ]
        },
        navBarRoutes.apiTokens,
        {
            ...navBarRoutes.users,
            children: [
                navBarRoutes.searchUserByAppleOrder,
                navBarRoutes.accountCodes,
            ]
        },
    ],
    [SUPPORT_ROLE]: [
        {
            ...navBarRoutes.promocodes,
            children: [
                navBarRoutes.promocodeGroups,
            ]
        },
        {
            ...navBarRoutes.users,
            children: [
                navBarRoutes.searchUserByAppleOrder,
                navBarRoutes.accountCodes,
            ]
        },
        navBarRoutes.shortcutSearch
    ],
    [DEVOPS_ROLE]: [
        {
            ...navBarRoutes.nodes,
            children: [
                navBarRoutes.nodeServerBundles,
            ]
        },
    ]
};
